module.exports.LIKES_MESSAGE_TO_SIGN = `In order to verify that you are the owner of the Ethereum address used to like
this jingle, we need you to sign this message.`;
